import {
  FLIGHT_SESSION_EXPIRES_AT_KEY,
} from '../constants/flightSession.constants';
import { HOTEL_SESSION_EXPIRES_AT_PREFIX } from '../constants/hotelSession.constants';
import { SESSION_TIMER_PRODUCT } from '../constants/sessionTimer.constants';

function parseExpiryMs(value) {
  if (value == null || value === '') return null;
  const expiryMs = Date.parse(value) || Number(value);
  return Number.isFinite(expiryMs) ? expiryMs : null;
}

function readFlightExpiresAtMs() {
  if (typeof sessionStorage === 'undefined') return null;
  return parseExpiryMs(sessionStorage.getItem(FLIGHT_SESSION_EXPIRES_AT_KEY));
}

function readHotelExpiresAtMs(sessionId) {
  if (!sessionId || typeof sessionStorage === 'undefined') return null;
  return parseExpiryMs(sessionStorage.getItem(`${HOTEL_SESSION_EXPIRES_AT_PREFIX}${sessionId}`));
}

export function readSessionExpiresAtMs({ product = SESSION_TIMER_PRODUCT.FLIGHT, sessionId } = {}) {
  if (product === SESSION_TIMER_PRODUCT.HOTEL) return readHotelExpiresAtMs(sessionId);
  return readFlightExpiresAtMs();
}

export function getSessionRemainingMs(options = {}, nowMs = Date.now()) {
  const expiresAt = readSessionExpiresAtMs(options);
  if (expiresAt == null) return null;
  const left = expiresAt - nowMs;
  return left > 0 ? left : 0;
}

export function formatSessionTimerLabel(remainingMs) {
  const totalSeconds = Math.ceil(Number(remainingMs) / 1000);
  const safeSeconds = Number.isFinite(totalSeconds) ? Math.max(0, totalSeconds) : 0;
  const minutes = Math.floor(safeSeconds / 60);
  const seconds = safeSeconds % 60;
  return {
    active: true,
    expired: remainingMs <= 0,
    minutes,
    seconds,
    totalSeconds: safeSeconds,
    label: `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`,
  };
}

export function sessionTimerView(options = {}, nowMs = Date.now()) {
  const remaining = getSessionRemainingMs(options, nowMs);
  if (remaining == null) {
    return { active: false, expired: false, minutes: 0, seconds: 0, totalSeconds: 0, label: null };
  }
  return formatSessionTimerLabel(remaining);
}
